// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"617":"d78d69ff","744":"4746c928"}[chunkId] + ".chunk.css";
};